import Box from '@mui/material/Box'
import Chip from '@mui/material/Chip'
import CodeIcon from '@mui/icons-material/Code'
import type { PendingWebsiteTarget } from './types'

export function TargetChipBar({ targets, onRemove, disabled = false }: {
  targets: PendingWebsiteTarget[]
  onRemove?: (targetId: string) => void
  disabled?: boolean
}) {
  if (!targets.length) return null
  return (
    <Box aria-label="Selected website elements" sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
      {targets.map(target => (
        <Chip
          key={target.targetId}
          size="small"
          icon={<CodeIcon sx={{ fontSize: '15px !important' }} />}
          label={<><Box component="span" sx={{ fontWeight: 700, mr: 0.5 }}>{target.ordinal}</Box>{target.label}</>}
          onDelete={!disabled && onRemove ? () => onRemove(target.targetId) : undefined}
          sx={{ maxWidth: 280, '& .MuiChip-label': { overflow: 'hidden', textOverflow: 'ellipsis' } }}
        />
      ))}
    </Box>
  )
}
